// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__sHDsA","content":"tooltip_content__RlHUG"};